import styles from '../UnifyOnboarding.module.scss';

export const CurrentConnectionInfo = ({ source, provider, kind = 'stock' }) => {
	const isStock = kind === 'stock';
	const title = isStock ? 'Current stock inventory connection' : 'Current product data connection';

	if (!source) {
		return null;
	}

	const providerLabel = provider?.label || source.providerLabel;

	return (
		<div className={`${styles.completedInfo} ${styles.completedInfoWithMargin}`}>
			<div>
				<p>
					<strong>{title}</strong>
				</p>
				<p className={styles.helperText}>
					Connected via {providerLabel}
				</p>
				{source.latestIngest?.timestamp && (
					<p className={styles.helperText}>
						Last synced: {new Date(source.latestIngest.timestamp).toLocaleString()}
					</p>
				)}
			</div>
		</div>
	);
};
